"use strict";

var validation = function () {
  function setFieldInvalid($valueArea, errorMessage) {
    $valueArea.attr('data-error', errorMessage);
    $valueArea.addClass('-error');
    var $desc = $valueArea.find('.field-label-description');
    $desc.text(errorMessage);
  }

  function setFieldValid($valueArea) {
    $valueArea.removeAttr('data-error');
    $valueArea.removeClass('-error');
    var $desc = $valueArea.find('.field-label-description');
    var fieldDesc = $valueArea.attr('data-label-desc') || '';
    $desc.text(fieldDesc);
  }

  function setAllValid(validationForm) {
    $(validationForm).find('[data-error]').each(function () {
      var fieldDesc = $(this).attr('data-label-desc') || '';
      $(this).removeAttr('data-error');
      $(this).removeClass('-error');
      $(this).find('.field-label-description').text(fieldDesc);
    });
  }

  function setGridItemInvalid($gridItem) {
    if ($gridItem.hasClass('text-required')) {
      $gridItem.addClass('text-invalid');
    } else {
      $gridItem.find('.text-required').addClass('text-invalid');
    }
  }

  function setGridValid($grid) {
    $grid.find('.text-invalid').removeClass('text-invalid');
  }

  function getPropValue($valueArea, dataSet) {
    var propName = $valueArea.attr('data-prop-name');
    var propNameParts = propName.split('.');
    var value = null;

    if (propNameParts.length > 1) {
      value = propNameParts.reduce(function (oldValue, newValue) {
        return oldValue[newValue];
      }, dataSet);
    } else {
      value = dataSet[propName];
    }

    return value;
  }

  function validateRequiredValues(dataSet, $checkArea) {
    var allValid = true;
    var $requiredFields = $checkArea ? $checkArea.find('[data-required]') : $('[data-required]');
    $requiredFields.each(function (index, valueArea) {
      var $valueArea = $(valueArea);
      var value = getPropValue($valueArea, dataSet);
      var errorMssg = $valueArea.data('custom-required-mssg') || "\u041D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435";

      if (!value) {
        console.log($valueArea);
        setFieldInvalid($valueArea, errorMssg);
        allValid = false;
      }
    });
    return allValid;
  }

  function validateRegistrationForm() {
    var allValid = true;
    var personConfirm = $('#personConfirm').is(':checked');
    $('[data-required]').each(function (idx, field) {
      var val = '';
      var $input = $(field).find('input');

      switch ($input.attr('type')) {
        case 'tel':
        case 'text':
          val = $input.val().trim();
          break;

        case 'checkbox':
          val = $input.is(':checked');
          break;

        default:
          console.error('Field type not found');
          break;
      }

      if (!val) {
        allValid = false;
      }
    });
    $('.person-contract-list .person-contract-number').each(function (idx, contract) {
      var val = $(contract).val().trim();

      if (!val) {
        allValid = false;
      }
    });

    if (!personConfirm) {
      allValid = false;
    }

    return allValid;
  }
  /* function validateConditionallyRequired(dataSet) {
      let allValid = true;
      $('[data-conditionaly-required]').each((index, valueArea) => {
          const $valueArea = $(valueArea);
          const value = getPropValue($valueArea, dataSet);
            if (!value) {
              setFieldInvalid($valueArea, 'Не заполнено обязательное поле');
              allValid = false;
          }
      });
      return allValid;
  } */


  function validateValuesLength(dataSet) {
    var allValid = true;
    $('[data-max-length]').each(function (index, valueArea) {
      var $valueArea = $(valueArea);
      var value = getPropValue($valueArea, dataSet);
      var maxLength = $valueArea.attr('data-max-length');
      var errorMssg = $valueArea.data('custom-maxlen-mssg') || "\u041F\u0440\u0435\u0432\u044B\u0448\u0430\u0435\u0442 ".concat(maxLength, " \u0441\u0438\u043C\u0432\u043E\u043B\u043E\u0432");

      if (value && value.length > maxLength) {
        setFieldInvalid($valueArea, errorMssg);
        allValid = false;
      }
    });
    return allValid;
  }

  function validatePasswEqual(dataSet) {
    var valid = true;
    var $passwArea = $('[data-prop-name="passw"]');
    var $dupPasswArea = $('[data-prop-name="dupPassw"]');
    var passwValue = getPropValue($passwArea, dataSet);
    var dupPasswValue = getPropValue($dupPasswArea, dataSet);

    if (dupPasswValue !== passwValue) {
      setFieldInvalid($dupPasswArea, 'Пароли не совпадают');
      valid = false;
    }

    return valid;
  }

  function validatePattern(dataSet) {
    var allValid = true;
    $('[data-pattern]').each(function (index, valueArea) {
      var $valueArea = $(valueArea);
      var value = getPropValue($valueArea, dataSet);
      var pattern = $valueArea.attr('data-pattern');

      switch (pattern) {
        case 'phone':
          {
            var phoneRgx = /^((\+[\d]{1,3})[\- ]?)[\d]{6,12}$/;

            if (value && value.trim() !== '' && !phoneRgx.test(value)) {
              setFieldInvalid($valueArea, 'Некорректный формат номера');
              allValid = false;
            }

            break;
          }

        case 'email':
          {
            var mailRgx = /^(([^<>()+[\]\\.,;:\s@"]+(\.[^<>()+[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (value && value.trim() !== '' && !mailRgx.test(value)) {
              setFieldInvalid($valueArea, 'Некорректный формат эл. почты');
              allValid = false;
            }

            break;
          }
        // only numbers

        default:
          {
            break;
          }
      }
    });
    return allValid;
  }

  function validatePrivacyAgree(dataSet) {
    var valid = true;
    var $privacyConfirmArea = $('[data-prop-name="privacyConfirm"]');
    var privacyConfirmValue = getPropValue($privacyConfirmArea, dataSet);

    if (!privacyConfirmValue) {
      setFieldInvalid($privacyConfirmArea, 'Отправляя форму Вы даете согласие на обработку перс. данных');
      valid = false;
    }

    return valid;
  }

  function validateContracts(dataSet) {
    var contractTypeDict = {
      'clientContract': 'Договор',
      'customerAccount': 'Лицевой счет'
    };
    var allValid = true;
    dataSet.ContractBindingList.forEach(function (contract) {
      var $valueArea = $('[data-contracts]');
      var value = contract.ObjectNumber;
      var obj = contract.BuldingObjectId;
      var existingItem = $.grep(dataSet.ExistingContractsList, function (item) {
        return item.ContractOrCa === contractTypeDict["".concat(contract.EntityType)] && item.BuldingObject === contract.BuldingObject && item.ObjectNumber === contract.ObjectNumber;
      })[0];

      if (!value) {
        setFieldInvalid($valueArea, "\u041D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D \u043D\u043E\u043C\u0435\u0440 ".concat(contract.EntityType === 'clientContract' ? 'договора' : 'лицевого счета'));
        allValid = false;
      }

      if (!obj) {
        setFieldInvalid($valueArea, 'Не выбран объект');
        allValid = false;
      }

      if (existingItem) {
        setFieldInvalid($valueArea, 'Информация об этом договоре уже внесена');
        allValid = false;
      }
    });
    return allValid;
  }

  function validateFileExt(dataSet) {
    var valid = true;
    var $attachArea = $('[data-prop-name="attachment"]');
    var attachValue = getPropValue($attachArea, dataSet);
    var splittedFileName = attachValue.split('.');
    var fileType = splittedFileName.slice(-1)[0].toLowerCase();
    var allowedFormats = ['png', 'pdf', 'doc', 'docx', 'jpg', 'jpeg'];

    if (splittedFileName.length < 2) {
      setFieldInvalid($attachArea, 'Данный формат файла не разрешен для добавления');
      valid = false;
    }

    if (allowedFormats.indexOf(fileType) === -1) {
      setFieldInvalid($attachArea, 'Данный формат файла не разрешен для добавления');
      valid = false;
    }

    return valid;
  }

  function validateFileSize(dataSet) {
    var valid = true;
    var $attachArea = $('[data-prop-name="attachment"]');
    var attachValue = getPropValue($attachArea, dataSet);

    if (attachValue > 10 * 1024 * 1024) {
      setFieldInvalid($attachArea, 'Размер файла не должен превышать 10 Мб');
      valid = false;
    }

    return valid;
  }

  function validatePollGridRowFill(dataSet) {
    var valid = true;
    var $valueArea = dataSet.$el;
    $valueArea.find('.rest-columns .trow').each(function (idx) {
      var $this = $(this);
      var $selectedChoice = $this.find('[data-sf-role="multiple-grid-choice-field-input"]:checked');

      if (!$selectedChoice.length) {
        var $gridItem = $valueArea.find(".fix-column .trow:nth-child(".concat(idx + 1, ")"));
        setGridItemInvalid($gridItem);
        valid = false;
      }
    });

    if (!valid) {
      setFieldInvalid($valueArea, 'Не заполнены обязательные поля');
    }

    return valid;
  }

  function validatePollGridColFill(dataSet) {
    var valid = true;
    var $valueArea = dataSet.$el;
    var colsCount = parseInt(dataSet.$el.find('.fixed-tbl-wrapper').data('cols-count'), 10);

    for (var i = 0; i < colsCount; i++) {
      var $selectedChoice = dataSet.$el.find("[data-dd-col=\"".concat(i, "\"]:checked"));

      if (!$selectedChoice.length) {
        var $gridItem = $valueArea.find(".rest-columns .th:nth-child(".concat(i + 1, ")"));
        setGridItemInvalid($gridItem);
        valid = false;
      }
    }

    if (!valid) {
      setFieldInvalid($valueArea, 'Не заполнены обязательные поля');
    }

    return valid;
  }

  function validatePollGridComment(dataSet) {
    var valid = true;
    var $valueArea = dataSet.$el;
    $valueArea.find('.rest-columns .trow').each(function (idx) {
      var $this = $(this);
      var $comment = $this.find('[data-dd-type="Comment"]');

      if ($comment.val() == "") {
        var $gridItem = $valueArea.find(".fix-column .trow:nth-child(".concat(idx + 1, ")"));
        setGridItemInvalid($gridItem);
        var $col = $valueArea.find('.-com');
        setGridItemInvalid($col);
        valid = false;
      }
    });

    if (!valid) {
      setFieldInvalid($valueArea, 'Не заполнены обязательные комментарии');
    }

    return valid;
  }

  function validatePollGridAdditionalChoice(dataSet) {
    var valid = true;
    var $valueArea = dataSet.$el;
    $valueArea.find('.rest-columns .trow').each(function (idx) {
      var $this = $(this);
      var $ac = $this.find('[data-dd-type="AdditionalChoice"]');

      if ($ac.val() == "") {
        var $gridItem = $valueArea.find(".fix-column .trow:nth-child(".concat(idx + 1, ")"));
        setGridItemInvalid($gridItem);
        var $col = $valueArea.find('.-ac');
        setGridItemInvalid($col);
        valid = false;
      }
    });

    if (!valid) {
      setFieldInvalid($valueArea, 'Не заполнены обязательные дополнительные варианты');
    }

    return valid;
  }

  function scrollToFirstError() {
    var scrollAreaSelector = 'html, body';
    $(scrollAreaSelector).animate({
      scrollTop: $('[data-error]:visible:first').offset().top - 100
    }, 500);
  }

  function validateRanking(dataSet, $checkArea) {
    var allValid = true;
    var $requiredFields = $checkArea.find('[data-ranking-valid]');
    $requiredFields.each(function (index, valueArea) {
      var $valueArea = $(valueArea);
      var value = $valueArea.find('[data-role="choices-select"] option[value="rate_default"]:selected').length == 0;
      var errorMssg = $valueArea.data('ranking-valid-message') || "\u041D\u0435 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u043E \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435";

      if (!value) {
        console.log($valueArea);
        setFieldInvalid($valueArea, errorMssg);
        allValid = false;
      }
    });
    return allValid;
  }
  /* function regexValues() {
      // str.replace(/</g, '&lt;').replace(/>/g, '&gt;');
  } */


  return {
    setFieldInvalid: setFieldInvalid,
    setFieldValid: setFieldValid,
    setAllValid: setAllValid,
    setGridValid: setGridValid,
    validateRequiredValues: validateRequiredValues,
    validateRegistrationForm: validateRegistrationForm,
    validateValuesLength: validateValuesLength,
    validatePasswEqual: validatePasswEqual,
    validatePattern: validatePattern,
    validatePrivacyAgree: validatePrivacyAgree,
    validateContracts: validateContracts,
    validateFileExt: validateFileExt,
    validateFileSize: validateFileSize,
    // validateConditionallyRequired,
    validatePollGridRowFill: validatePollGridRowFill,
    validatePollGridColFill: validatePollGridColFill,
    scrollToFirstError: scrollToFirstError,
    // regexValues,
    validatePollGridComment: validatePollGridComment,
    validatePollGridAdditionalChoice: validatePollGridAdditionalChoice,
    validateRanking: validateRanking
  };
}();